export enum PersistedQueryKey {
  useLinkedinInMailConfig = 'useLinkedinInMailConfig',
}
